//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.FeatureGeomBuilder.js";
import "../CAM/CAM.TrimPlane.js";
import "../CAM/CAM.TrimPoint.js";
let d=[[[1,"AxialTrimPlane1Builder",0,"CAM.TrimPlane",0],[1,"AxialTrimPlane2Builder",0,"CAM.TrimPlane",0],[0,"CutRegionSelectionMode",1,0],[0,"CutRegionSelectionPoint",1,"Point",0],[1,"RadialTrimPlane1Builder",0,"CAM.TrimPlane",0],[1,"RadialTrimPlane2Builder",0,"CAM.TrimPlane",0],[0,"SurfaceSensitivityMode",1,0],[0,"SurfaceSensitivityTolerance",1,0],[0,"ToleranceOffsetMode",1,0],[1,"TrimPoint1Builder",0,"CAM.TrimPoint",0],[1,"TrimPoint2Builder",0,"CAM.TrimPoint",0]],[],[]];
SPLM.CAM.TurnFeatureGeomBuilder = class extends SPLM.CAM.FeatureGeomBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TurnFeatureGeomBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.TurnFeatureGeomBuilder.SurfaceSensitivityModes = Object.freeze({
    "None" : "None", "Distance" : "Distance"});

SPLM.CAM.TurnFeatureGeomBuilder.ToleranceOffsetModes = Object.freeze({
    "AfterContainment" : "AfterContainment", "BeforeContainment" : "BeforeContainment"});

SPLM.CAM.TurnFeatureGeomBuilder.CutRegionSelectionModes = Object.freeze({
    "Automatic" : "Automatic", "Manual" : "Manual"});

export default SPLM;